// make our action generators utility functions for ease of use. Practically there is no difference between
// this method and just calling dispatch({ type: '', payload: {} }) with the appropriate values
const payloadLoadedAction = payload => {
    return { type: 'PAYLOAD_LOADED', payload };
};

export default payloadLoadedAction;


// WEBPACK FOOTER //
// ./src/actions/payloadLoadedAction.js